"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Settings = {
  staging: {
    url: "https://tracking-api.buildstaging.com/rest/track"
  },
  production: {
    url: "https://tracking-api.hotmart.com/rest/track"
  }
};
exports.default = Settings;